//社交管理
export default [
  {
    path: '/circleManage',
    component: () => import('../pages/socialManage/circleManage.vue'),
    name: 'circleManage',
    title: "圈子管理",
    meta: {
      title: "圈子管理"
    }
  },
  {
    path: '/topicManage',
    component: () => import('../pages/socialManage/topicManage.vue'),
    name: 'topicManage',
    title: "帖子管理",
    meta: {
      title: "帖子管理"
    }
  },
  {
    path: '/tencentVideoManage',
    component: () => import('../pages/socialManage/tencentVideoManage.vue'),
    name: 'tencentVideoManage',
    title: "视频管理",
    meta: {
      title: "视频管理"
    }
  },
  {
    path: '/wxLiveManage',
    component: () => import('../pages/socialManage/wxLiveManage.vue'),
    name: 'wxLiveManage',
    title: "直播管理",
    meta: {
      title: "直播管理"
    }
  },
  {
    path: '/smallVideoManage',
    component: () => import('../pages/socialManage/smallVideoManage.vue'),
    name: 'smallVideoManage',
    title: "短视频管理",
    meta: {
      title: "短视频管理"
    }
  },
];
